import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import React, { Component ,createRef, Fragment} from 'react'
import WIAuthorContainerPDF from './wi_author_container_pdf'
import WIAuthorContainerSteps from './wi_author_container_steps'
import WIAuthorC from './WIAuthor';
import { imageExtensions, audioExtensions, videoExtensions, documentExtensions} from "../../../Templates/data"
import { checkNotUndefindeNull, findExtension,isModel,replaceSpanWithTextInString } from "../../../Templates/functions"
import { circleExclamation, AnnotationModelIcon, tocToggleIcon, dotsIcon,closeStepAlertsIcon, countStepAlerts,openStepAlertsIcon,addAttachmentIcon  } from "../../../Templates/icons"
import { cloneDeep, isEmpty, isEqual, mapKeys } from 'lodash'
import axios from 'axios'
import 'react-tabs/style/react-tabs.css';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';

class WIAuthorParent extends Component {
    constructor(props) {
        super()
        this.state={
            tabList:[],
            tabPageList:[],
            tabIndex:0,
            parentID:null,
            parentTitle:null,
            currentSelectedWI:null,
            isPDF:false
        }
    }

    componentDidMount=()=>{
            // Isolate paints for react-tabs to prevent bottom-bar flicker
            try {
                // Remove existing style if it exists to ensure fresh application
                const existingStyle = document.getElementById('wi-tabs-iso');
                if (existingStyle) {
                    existingStyle.remove();
                }
                
                const style = document.createElement('style');
                style.id = 'wi-tabs-iso';
                style.textContent = `
                    /* Hide all tab panels by default */
                    .react-tabs__tab-panel { 
                        display: none !important; 
                    }
                    
                    /* Show only the selected tab panel with full height */
                    .react-tabs__tab-panel--selected { 
                        display: flex !important; 
                        flex: 1 1 auto !important;
                        min-height: 0 !important;
                        height: 100% !important;
                        width: 100% !important;
                        overflow: hidden !important;
                        flex-direction: column !important;
                        position: relative !important;
                    }
                    
                    /* Ensure the Tabs container is proper flex */
                    .react-tabs { 
                        display: flex !important;
                        flex-direction: column !important;
                        height: 100% !important;
                        width: 100% !important;
                    }
                    
                    #wi-author-header { 
                        contain: paint layout !important; 
                        transform: translateZ(0); 
                    }
                `;
                document.head.appendChild(style);
                console.log('[WIAuthorParent] Tab panel styles injected');
            } catch (e) {
                console.error('[WIAuthorParent] Failed to inject styles:', e);
            }
            let info = this.props.location.pathname.split('/').pop()
            let pdf = this.props.location.search.includes("pdf") && this.props.location.search.includes("true")
            this.setState({parentTitle:info.split("~&~")[1],parentID:info.split("~&~")[0],currentSelectedWI:"react-tabs-0",isPDF:pdf},()=>{
                this.addTab(this.state.parentTitle, this.state.parentID, true)
            })
    }

    componentDidUpdate(prevProps, prevState){
        // Only log if tabPageList length actually changed
        if (prevState.tabPageList.length !== this.state.tabPageList.length) {
            console.log(`[Parent] tabPageList length changed: ${prevState.tabPageList.length} -> ${this.state.tabPageList.length}`);
        }
    }

    addTab=(title,wip_ID ,first)=>{
        let tabList = cloneDeep(this.state.tabList)
        let tabPageList = cloneDeep(this.state.tabPageList)
        console.dir(tabList)
        if (tabList.length > 0 && tabList.filter(t =>  t.props.id.includes(wip_ID)  ).length > 0){
            alert("This WI is already open.")
        }else{
            // For nested WIs, fetch the actual WI info to determine if it's PDF and if it's published
            if (!first) {
                axios.get(`${window.config.getApiBaseUrl()}/api/wip/${wip_ID}`)
                    .then(response => {
                        const wiData = response.data;
                        // Check if WI is published (release && isAssignable both true)
                        const isPublished = wiData.release === true && wiData.isAssignable === true;
                        // Create both tab and panel together with correct type
                        let tab = this.createTab(title,wip_ID,first)
                        let tabPage = this.createTabPage(wip_ID,title,wiData.isPDFViewer,isPublished)
                        
                        tabList.push(tab)
                        tabPageList.push(tabPage)
                        
                        // Update both in a single setState to avoid mismatch
                        this.setState({tabList, tabPageList})
                    })
                    .catch(error => {
                        console.error('Failed to fetch WI info for nested tab:', error);
                        const status = error?.response?.status;
                        const msg = error?.response?.data?.message || '';
                        if (status === 404 || status === 410 || /deleted|not found/i.test(msg)) {
                            alert('This Work Instruction has been deleted.');
                            return; // Do not add a tab for deleted/removed WIs
                        }
                        // For other errors, fallback to title-based detection (assume not published for safety)
                        let tab = this.createTab(title,wip_ID,first)
                        let tabPage = this.createTabPage(wip_ID,title,undefined,false)
                        
                        tabList.push(tab)
                        tabPageList.push(tabPage)
                        
                        this.setState({tabList, tabPageList})
                    });
            } else {
                // For the first tab, use the existing logic (parent WI is always editable)
                let tab = this.createTab(title,wip_ID,first)
                let tabPage = this.createTabPage(wip_ID,title,undefined,false)
                
                tabList.push(tab)
                tabPageList.push(tabPage)
                
                this.setState({tabList, tabPageList})
            }
        }
    }

    createTab =(title,wip_ID,first)=>{
        let svg = <div id={`div_${wip_ID}`} className="tabExit" style={{zIndex:"100",display:"inline-block"}} onClick={this.handleEvent}><svg id={`svg_${wip_ID}`} className="clickable"  xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                        <path id={`path_${wip_ID}`} d="M7.5 0C3.3525 0 0 3.3525 0 7.5C0 11.6475 3.3525 15 7.5 15C11.6475 15 15 11.6475 15 7.5C15 3.3525 11.6475 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5ZM10.1925 3.75L7.5 6.4425L4.8075 3.75L3.75 4.8075L6.4425 7.5L3.75 10.1925L4.8075 11.25L7.5 8.5575L10.1925 11.25L11.25 10.1925L8.5575 7.5L11.25 4.8075L10.1925 3.75Z" fill="#D7493F" />
                        </svg>
                  </div>
        if(this.state.parentID === wip_ID){
            svg = ""
        }
        let tab = <Tab defaultFocus={first ? true : false}  id={"list_" + wip_ID}>{title} {svg}</Tab>
        return tab
    }

    createTabPage=(wip_ID,title,isPDFViewer,isPublished)=>{
        // Only the parent WI should be editable
        const isNestedWI = wip_ID !== this.state.parentID;
        // Nested WIs should be read-only (lite view) if:
        // 1. They are published (release && isAssignable both true), OR
        // 2. They are opened from WIAuthorLite (but we're in WIAuthorParent, so this doesn't apply here)
        // Otherwise, nested WIs should be editable (regular mode)
        const shouldBeLiteView = isNestedWI && (isPublished === true);
        // Use isPDFViewer if provided, otherwise fall back to title-based detection
        const shouldUsePDF = isPDFViewer !== undefined ? isPDFViewer : title.toLowerCase().includes("pdf");
        
        let tabPage = <TabPanel key={`tabpanel_${wip_ID}`} id={"page_" + wip_ID} className="tabPageElement">
                      {shouldUsePDF ?  
                            <WIAuthorContainerPDF wip_ID={wip_ID} addTab={this.addTab} editTitle={this.editTitle} isLiteView={shouldBeLiteView}>
                            </WIAuthorContainerPDF>
                            
                      :     <WIAuthorContainerSteps wip_ID={wip_ID} addTab={this.addTab} editTitle={this.editTitle} isLiteView={shouldBeLiteView}>
                            </WIAuthorContainerSteps>}  
                      </TabPanel>
        return tabPage
    }

    editTitle=(title,wip_ID)=>{
        let oldTab = this.state.tabList.find(t => t.props.id.includes(wip_ID))
        let tabIndex = this.state.tabList.indexOf(oldTab)
        let tabList = cloneDeep(this.state.tabList)
        let newTab = this.createTab(title,wip_ID,false) 
        tabList[tabIndex] = newTab
        this.setState({tabList})
    }

    // Keep the old addTabPage for backward compatibility if needed
    addTabPage=(wip_ID,title)=>{
        let tabPageList = cloneDeep(this.state.tabPageList)
        // For backward compatibility, assume not published
        let tabPage = this.createTabPage(wip_ID,title,undefined,false)
        tabPageList.push(tabPage)
        this.setState({tabPageList},()=>{
          
        })
    }

    removeTab=(wip_ID,parentID)=>{
        let tl = cloneDeep(this.state.tabList)
        let tabList = tl.filter(t => !t.props.id.includes(wip_ID))
        let selectedTab = document.getElementsByClassName("react-tabs__tab--selected")[0]
        if(this.state.currentSelectedWI === selectedTab.id){
            if(this.state.tabIndex === 0){
                this.setState({tabList,tabIndex:0},()=>{
                    this.removeTabPage(wip_ID, parentID, selectedTab.id)
                })
            }else{
                this.setState({tabList,tabIndex:this.state.tabIndex - 1},()=>{
                    this.removeTabPage(wip_ID, parentID, selectedTab.id)
                })
            }
        }
        else{
            this.setState({tabList},()=>{
            this.removeTabPage(wip_ID, parentID, selectedTab)
            })
        }
    }

    removeTabPage=(wip_ID,parentID, selectedTabID)=>{
        let tpl = cloneDeep(this.state.tabPageList)
        let tabPageList = tpl.filter(tp=>  !tp.props.id.includes(wip_ID) )
        if(this.state.tabIndex === 0 || selectedTabID !== parentID){
            this.setState({tabPageList, tabIndex: 0})  
        }else{
          this.setState({tabPageList,tabIndex:this.state.tabIndex - 1})  
        }      
    }

    handleEvent=(e)=>{
        e.preventDefault();
        e.stopPropagation();
        this.removeTab(e.target.id.split("_")[1],e.target.parentElement.parentElement.id)
    }

    setIndex=(index)=>{
        console.log(`[Parent] Switching to tab index: ${index.index}`);
        const tabInfo = this.state.tabList[index.index];
        console.log(`[Parent] Switching to WI:`, tabInfo?.props?.id);
        console.log(`[Parent] Current active element before switch:`, document.activeElement);
        this.setState({tabIndex:index.index},()=>{
            let selectedTab = document.getElementsByClassName("react-tabs__tab--selected")[0]
            this.setState({currentSelectedWI:selectedTab.id})
            console.log(`[Parent] Tab switch complete, new selected tab:`, selectedTab.id);
            
            // Debug: Check tab panels
            const allPanels = document.querySelectorAll('.react-tabs__tab-panel');
            const selectedPanels = document.querySelectorAll('.react-tabs__tab-panel--selected');
            console.log(`[Parent] Total panels: ${allPanels.length}, Selected panels: ${selectedPanels.length}`);
            allPanels.forEach((panel, i) => {
                const computedStyle = window.getComputedStyle(panel);
                console.log(`[Parent] Panel ${i}: display=${computedStyle.display}, id=${panel.id}, classes=${panel.className}`);
            });
        })          
    }
 
    render=()=>{  
        // Remove console.log to prevent infinite render loop from logging itself
        return <div id="wi-author-page" className="relative" style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    height: '93%', 
                    width: '100%',
                    boxSizing: 'border-box',
                    position: 'relative',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    paddingBottom: '8px'
                }}>
                    <div id="wi-author-container" className="flex" style={{ 
                        flex: '1 1 auto',
                        overflowX: 'hidden',
                        overflowY: 'auto',
                        width: '94%',
                        margin: '1em auto 0 auto',
                        marginBottom: '8px',
                        position: 'relative',
                        zIndex: 1,
                        minHeight: 0,
                        boxShadow: '0 7px 5.8px 0 rgba(0, 0, 0, 0.25)'
                    }}>
                        <Tabs selectedIndex={this.state.tabIndex} onSelect={(index) => this.setIndex({index})} style={{ 
                            width: '100%', 
                            height: '100%', 
                            display: 'flex', 
                            flexDirection: 'column',
                            minHeight: 0
                        }}>
                            <div id="wi-author-header" className="flex-centered max-width" style={{
                                flex: '0 0 auto'
                            }}>
                                <TabList>
                                    {this.state.tabList }
                                </TabList>
                            </div> 
                            {this.state.tabPageList} 
                        </Tabs>
                    </div>
                </div>
                
            }
}
export default withRouter(WIAuthorParent)